import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PrepareRecipeComponent } from './components/recipes/prepare-recipe/prepare-recipe.component';
import { RecipeDetailsComponent } from './components/recipes/recipe-details/recipe-details.component';
import { RecipeListComponent } from './components/recipes/recipe-list/recipe-list.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'recipes',
    component: RecipeListComponent,
  },
  {
    path: 'profile',
    component: ProfileComponent,
  },
  {
    path: 'prepare-recipe',
    component: PrepareRecipeComponent,
  },
  {
    path: ':recipeId',
    children: [
      {
        path: ':recipeName',
        component: RecipeDetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
